module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./TemplateMgmtView.jsx"));
	}, "TemplateMgmt");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=TemplateMgmt!./src/pages/bundle-appResource-mgmt/TemplateMgmt/TemplateMgmtView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=TemplateMgmt!./src/pages/bundle-appResource-mgmt/TemplateMgmt/TemplateMgmtView.jsx
// module chunks = 43